import summary from 'reducers/dashboard/driveoff/summary';
import { combineReducers } from 'redux';

export default combineReducers({
  summary,
});
